import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import { FormattedMessage } from "react-intl";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import {
  ADDITIONAL_METRICS_VIEW,
  AR_V2,
  TABULAR_GRID_VIEW,
  VISUAL_GRID_VIEW,
} from "../util/Constants";
import { OutboundFilterContext } from "../context/OutboundFilterContext";
import { CapabilityContext } from "../../overview/context/CapabilityContext";
import { isARorSSD } from "../util/Util";
import { useDeviceLayout } from "../../common/context/DeviceLayoutContext";

const WaveViewSelector = () => {
  const { spacingInset_shorthand4 } = useDeviceLayout();
  const { viewModelF, dispatchF } = useContext(OutboundFilterContext);
  const { capability } = useContext(CapabilityContext);

  const toggleView = (newValue) => {
    dispatchF({ type: "SELECT_WAVE_VIEW", waveViewType: newValue });
  };

  return (
    <div>
      <Row spacingInset={spacingInset_shorthand4}>
        {!isARorSSD(capability.data) ? (
          <ButtonGroup value={viewModelF.waveViewType} onChange={toggleView}>
            <ButtonOption value={VISUAL_GRID_VIEW}>
              <FormattedMessage
                id="outboundAMZL.visualView"
                defaultMessage="Visual view"
              />
            </ButtonOption>
            <ButtonOption value={TABULAR_GRID_VIEW}>
              <FormattedMessage
                id="outboundAMZL.tableView"
                defaultMessage="Table view"
              />
            </ButtonOption>
            {capability.data === AR_V2 && (
              <ButtonOption value={ADDITIONAL_METRICS_VIEW}>
                <FormattedMessage
                  id="outboundARv2.additionalMetricsView"
                  defaultMessage="Additional metrics"
                />
              </ButtonOption>
            )}
          </ButtonGroup>
        ) : null}
      </Row>
    </div>
  );
};

export default WaveViewSelector;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/routegridview/WaveViewSelector.js